import * as React from 'react'
import { useSearchParams } from 'react-router-dom';
import Loader from '../Components/Loader';
import { DataService } from '../DataService/DataService';

export const AcceptRebook = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = React.useState<'ready' | 'accepted' | 'invalid' | 'error' | 'submitting'>('ready');

  const requestId = searchParams.get('requestId');
  const slotId = searchParams.get('slotId');
  const date = searchParams.get('date');
  const startTime = searchParams.get('startTime');
  const endTime = searchParams.get('endTime');
  const category = searchParams.get('category') ?? 'public';

  React.useEffect(() => {
    if (!requestId || !slotId) {
      setStatus('invalid');
    }
  }, [requestId, slotId]);

  const categoryText = () => {
    switch (category) {
      case 'rot': return 'ROT';
      case 'grow': return 'GROW';
      case '__system-rot': return 'ROT';
      default: return 'Publik';
    }
  };

  const acceptRebooking = async () => {
    if (!requestId || !slotId) {
      setStatus('invalid');
      return;
    }

    try {
      setStatus('submitting');
      const result = await DataService.BookingService.AcceptRebookProposal(+requestId, +slotId);
      setStatus(result ? 'accepted' : 'invalid');
    } catch (error) {
      setStatus('error');
    }
  };


  const renderContent = () => {
    switch (status) {
      case 'submitting':
        return (
          <div className="text-center loading-message">
            <p className="text-secondary">Bekräftar din nya tid...</p>
            <div style={{ position: 'relative', display: 'flex', justifyContent: 'center' }}>
              <Loader loaderSize="LARGE" bgColor="#4b5563" />
            </div>
          </div>
        );

      case 'ready':
        return (
          <div className="text-center" style={{ display: 'grid', gap: 16 }}>
            <h2 className="heading text-primary">Bekräfta ny tid</h2>
            <p className="text-secondary description">
              Kontrollera tiden innan du skickar bekräftelsen.
            </p>
            <div style={{ border: '1px solid hsl(var(--border))', borderRadius: 16, padding: 16, textAlign: 'left' }}>
              <p style={{ margin: 0, fontWeight: 700 }}>{date ? `${date} ${startTime ?? ''} - ${endTime ?? ''}` : 'Vald tid saknas'}</p>
              <p style={{ marginTop: 8, marginBottom: 0, color: 'hsl(var(--muted-foreground))' }}>Kategori: {categoryText()}</p>
              <p style={{ marginTop: 8, marginBottom: 0, color: 'hsl(var(--muted-foreground))' }}>Förfrågan: #{requestId ?? '-'}</p>
            </div>
            <button className="submit-button" onClick={acceptRebooking} disabled={!requestId || !slotId}>
              Bekräfta tiden
            </button>
          </div>
        );

      case 'accepted':
        return (
          <div className="text-center">
            <h2 className="heading text-primary">✅ Ny tid är bokad!</h2>
            <p className="text-secondary description">
              Tack! Din nya tid är nu bekräftad.  
              Du kommer att få en bekräftelse via mail.
            </p>
            <button
              className="submit-button"
              onClick={() => (window.location.href = '/')}
            >
              Till startsidan
            </button>
          </div>
        );

      case 'invalid':
        return (
          <div className="text-center">
            <h2 className="heading text-primary">❌ Ogiltig eller föråldrad länk</h2>
            <p className="text-secondary description">
              Den här ombokningslänken är tyvärr ogiltig eller har gått ut.
              Kontakta oss om du behöver hjälp att boka ny tid.
            </p>
            <button
              className="submit-button"
              onClick={() => (window.location.href = '/contact')}
            >
              Kontakta oss
            </button>
          </div>
        );

      case 'error':
        return (
          <div className="text-center">
            <h2 className="heading text-primary">⚠️ Tekniskt fel</h2>
            <p className="text-secondary description">
              Något gick fel när vi försökte bekräfta din nya tid.
              Prova igen eller kontakta oss om problemet kvarstår.
            </p>
            <button className="submit-button" onClick={acceptRebooking}>
              Försök igen
            </button>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div style={{ minHeight: '100vh' }}>
      <div className="unsubscribe-page">
        <div className="unsubscribe-container">
          <div className="unsubscribe-card">
            {renderContent()}
          </div>
        </div>
      </div>
    </div>
  );
};
